export const environment = {
  production: false,
  environmentName: 'dev',
  apiUrl: 'https://vkomakbookinghub-devapi.vkomak.in/api',
  // Razorpay publishable key id — client-side by design, not a secret.
  razorpayKey: 'rzp_test_Si0s9UuWIczRvP'
};
